import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";

import { useropen } from '../../redux/userInfo';
import { open, close } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';

import * as APIS from "../../utils/service";
import queryString from 'query-string';


export default function Register({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { configdata } = useSelector(s => s.configReducer);
    const query = queryString.parse(location.search);
    console.log(query);
    const [reqname, setreqname] = useState(query?.name);   
    const [reqsex, setreqsex] = useState(query?.gender);   
    const [reqphpone, setreqphpone] = useState(query?.phone);   

    const [termlist, setconfigs] = useState(configdata?.consts?.termTypeConsts);   
    const [agreeall, setagreeall] = useState(false);   
    const [agreesellArr, setagreesellArr] = useState([]);   
    const [okresultData, setokresultData] = useState({});   

    const [agree1, setagree1] = useState(false);   
    const [agree2, setagree2] = useState(false);   
    const [agree3, setagree3] = useState(false);   
    const [agree4, setagree4] = useState(false);   
    const [agree5, setagree5] = useState(false);   
    const [agree6, setagree6] = useState(false);   
    const [submitflag, setsubmitflag] = useState(false);   

    useEffect(() => {
        let agreeArr = [];
        for(let i = 0; i < termlist?.length; i++){
            agreeArr.push(false);
        }
        console.log(agreeArr)
        setagreesellArr(agreeArr);
    }, []);
    useEffect(() => {
        let agreeArr2 = [];
        agreesellArr?.map((x, i) => {
            if(x === true){
                agreeArr2.push(true);
            }
        });
        
        if(agreeArr2?.length === agreesellArr?.length){
            setsubmitflag(true);
        } else {
            setsubmitflag(false);
        }
        if(agree1 && agree2 && agree3 && agree4 && agree5){
            setsubmitflag(true);
        } else {
            setsubmitflag(false);
        }
    }, [agreesellArr, agree1, agree2, agree3, agree4, agree5, agree6]);


    useEffect(() => {
        const script = document.createElement('script');
        const callBackFunc = document.createTextNode(
            "function result(result) {" +
                "try {" +
                    "result = JSON.parse(result);" +
                    "window.location.href='/Register2?name='+result?.data+'&phone='+result?.phone+'&gender='+result?.gender+'';" +
                "} catch (error) {" +
                "}" +
            "}");
        script.appendChild(callBackFunc);
        document.body.appendChild(script);
    }, []);
    const mok_popup = () => {
        window.MOBILEOK.process("https://api.maemul.net/mok_std_request", "WB", "result");
    }

    return(
        <Layout header={false}>
            <div className='normalform'>
                <div className='normalform_title'>회원가입</div>
                <div className='normalform_comment2'>서비스 약관에 동의해주세요.</div>

                <div className='register_checkall'>
                    <button type="button" onClick={() => { 
                        setagreeall(!agreeall);
                        let agreeArr = [];
                        if(agreeall === false){
                            for(let i = 0; i < termlist?.length; i++){
                                agreeArr.push(true);
                            }
                            setagree1(true);
                            setagree2(true);
                            setagree3(true);
                            setagree4(true);
                            setagree5(true);
                            setagree6(true);
                        } else {
                            for(let i = 0; i < termlist?.length; i++){
                                agreeArr.push(false);
                            }
                            setagree1(false);
                            setagree2(false);
                            setagree3(false);
                            setagree4(false);
                            setagree5(false);
                            setagree6(false);
                        }
                        setagreesellArr(agreeArr);  
                      
                    }}>
                        <div>
                            <img src={`./images/icons/BGM_${agreeall === false ? 'un': ''}check.svg`} style={{ width: 24, height: 24 }} />
                        </div>
                        <div>
                            <p>모두 동의합니다.</p>
                            <p>전체동의는 필수 및 선택정보에 대한 동의도 포함되어 있으며, 개별적으로도 동의를 선택하실 수 있습니다. 선택항목에 대한 동의를 거부하시는 경우에도 서비스 이용이 가능합니다.</p>
                        </div>
                    </button>
                </div>
                {termlist?.map((x, i) => {
                    return (
                        <div key={i} className='register_checks'>
                            <button type="button" onClick={() => { 
                                setagreesellArr(agreesellArr?.map((x2, i2) => i2 === i ? !agreesellArr[i] : x2 ));
                                if(i === 0){
                                    setagree1(!agree1);
                                } else if(i === 1){
                                    setagree2(!agree2);
                                } else if(i === 2){
                                    setagree3(!agree3);
                                } else if(i === 3){
                                    setagree4(!agree4);
                                } else if(i === 4){
                                    setagree5(!agree5);
                                } else if(i === 5){
                                    setagree6(!agree6);
                                }
                            }}>
                                <img src={`./images/icons/BGM_${agreesellArr[i] === false ? 'un': ''}check.svg`} style={{ width: 24, height: 24 }} />
                                <div>{x?.option === '필수' && "[필수] "}{x?.option === '선택' && "[선택] "}{x?.title}</div>
                            </button>
                            {x?.idx*1 > 0 &&
                            <button type="button" onClick={() => {
                                let sender = {
                                    type: x?.idx
                                }
                                APIS.postData('/term', sender).then(({ data }) => {
                                    //console.log(data);
                                    const PopComponents = () => {
                                        return (
                                            <div 
                                            dangerouslySetInnerHTML={{__html: data}}
                                            className='termContetns' 
                                            />
                                            
                                        );
                                    }
                                    dispatch(
                                        open({
                                            component: <PopComponents />,
                                            title: x?.title,
                                            titleviewer: true,                 
                                            alert: false,
                                            alertStyle: {
                                                width: 800
                                            }
                                        })
                                    );  
                                }).catch((e) => {
                                }).finally(() => {
                                });
                            }}>
                                보기{}
                            </button>       
                            }             
                        </div>                        
                    );
                })}

                 
                {/* <div className='normalform_comment' style={{ marginTop: 40 }}>서비스 이용을 위해 본인인증이 필요합니다.</div> */}
                <div className='loginbutton'>
                    <Button
                        disabled={submitflag ? false : true}
                        buttonTxt={'약관동의'}
                        onPress={() => {
                            if(submitflag){
                                //mok_popup();
                                navigate('/Register2', {state : {reqname: reqname, reqsex: reqsex, reqphpone: reqphpone, agree6: agree6 }});
                            }
                        }}
                    />
                </div>     
            </div>
        </Layout>
    )
}

